import { render, staticRenderFns } from "./BaseDictItemModal.vue?vue&type=template&id=74204734&scoped=true"
import script from "./BaseDictItemModal.vue?vue&type=script&lang=js"
export * from "./BaseDictItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74204734",
  null
  
)

export default component.exports